module.exports = __webpack_public_path__ + "img/DSC_0078.62900c8b.jpg";